import {
  SHAREINFOLIST,
  SHAREINFONEWSLIST
} from 'actions/shareInfo';
import {reducerPackage} from "../../utils";

export const shareInfoList = reducerPackage(SHAREINFOLIST);
export const shareInfoNewsList = reducerPackage(SHAREINFONEWSLIST);

